import { ActualizarClave } from './ActualizarClave'
import { SinSeleccion } from './SinSeleccion'
import { useEffect, useState } from 'react'

type Props = {
  opcion: string
}

export const ConfiguracionSeleccionada = ({ opcion }: Props) => {
  const [opcSeleccionada, setOpcSeleccionada] = useState(<SinSeleccion></SinSeleccion>)

  useEffect(() => {
    switch (opcion) {
      case 'seleccionar':
        setOpcSeleccionada(<SinSeleccion></SinSeleccion>)
        break
      case 'clave':
        setOpcSeleccionada(<ActualizarClave></ActualizarClave>)
        break
      default:
        setOpcSeleccionada(<SinSeleccion></SinSeleccion>)
    }
  }, [opcion])

  return (
    <>
      <div>{opcSeleccionada}</div>
    </>
  )
}
